import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../../../store/index';
import { changeActiveFrame, toggle, TRemoveModalFrame } from '../../../../../store/popups/remove';
import { IInitialProps, Initial } from './index';

function mapDispatchToProps(dispatch: Dispatch<IState>): IInitialProps {
  return {
    changeActiveFrame: (newActiveFrame: TRemoveModalFrame) => dispatch(changeActiveFrame(newActiveFrame)),
    close: () => dispatch(toggle(false)),
  };
}

export const InitialContainer = connect<{}, IInitialProps, {}>(() => ({}), mapDispatchToProps)(Initial);
